export default __webpack_public_path__ + "static/media/paySgGirl.5f20ed82.svg";